<template>
  <div class="create-candidate-second">
    <portlet
      :icon="'fad fa-file-plus'"
      :title="'Bestanden toevoegen'"
      :actionsBlock="true"
      :footer="true"
    >
      <template slot="actionsBlock">
        <button @click="$emit('switchPage', 'candidateInformation')" class="btn btn-secondary">
          <i class="fas fa-long-arrow-left mr-2"></i> Terug
        </button>
      </template>

      <template slot="portletBody">

        <div class="row">
          <div class="col-lg-3 upload-image-file">
            <picture-input
              ref="pictureInput"
              :crop="false"
              width="600"
              height="600"
              margin="16"
              accept="image/*"
              size="10"
              removeButtonClass="btn btn-dark btn-block"
              :hideChangeButton="true"
              :removable="true"
              :custom-strings="{
              upload: '📷 Upload profielfoto',
              drag: '📷 Upload profielfoto',
              tap: '📷 Upload profielfoto',
              change: 'Pas profielfoto aan',
              remove: '🗑️ Verwijder profielfoto'
            }"
              @change="handleProfileFileChange">
            </picture-input>

          </div>
          <div class="col-lg-9">
            <div class="row m-hide-xl">
              <div class="col">
                <label>Type</label>
              </div>
              <div class="col">
                <label>Naam</label>
              </div>
              <div class="col">
                <label>Bestand</label>
              </div>
              <div class="col last-repeat-col"></div>
            </div>
            <addDocuments
              v-for="(document,index) in documents"
              :key="index"
              :renderedComponent="renderedComponent"
              :document="document"
              :documentIndex="index"
              @documentRemoved="removeDocumentRow($event)"
            ></addDocuments>
          </div>
        </div>
      </template>
      <div slot="portletFooter" class="col-12 text-right">
        <button @click="addDocumentRow()" type="submit" class="btn btn-secondary">
          <i class="fa fa-plus mr-2"></i> Toevoegen
        </button>
      </div>
    </portlet>

    <portlet
      :icon="'fad fa-pencil'"
      :title="'Wat vind je van deze kandidaat'"
      :subTitle="'(Interne notitie)'"
      :footer="true"
    >
      <template slot="portletBody">
        <div class="form-group">
                    <textarea v-model="candidate.note" class="form-control" id="candidate-note"
                              v-validate="'required'" name="candidate-note" rows="4"></textarea>
        </div>
      </template>

      <div slot="portletFooter" class="col-12 text-center save-candidate">
        <button @click="saveCandidate('newCandidate')" type="submit" class="btn btn-primary">
          <i class="fas fa-user-plus"></i> Opslaan en nieuwe aanmaken
        </button>
        <button @click="saveCandidate" type="submit" class="btn btn-primary btn-save-close">
          <i class="fas fa-save"></i> Opslaan en sluiten
        </button>
        <button @click="saveCandidate('findVacancy')" type="submit" class="btn btn-primary btn-save-match">
          <i class="fas fa-search"></i> Opslaan en match
        </button>
        <button @click="saveCandidate('planAppointment')" type="submit" class="btn btn-primary btn-save-appointment">
          <i class="fas fa-calendar-plus"></i> Opslaan en afspraak plannen
        </button>
      </div>
    </portlet>
  </div>
</template>

<script>
  import addDocuments from "../../components/addDocuments";
  import {imageOrientation} from './../../components/mixins/imageOrientation.js';
  import {bsnChangeMarker} from '@/utils/bsn';

  export default {
    mixins: [imageOrientation],
    provide() {
      return {
        $validator: this.$validator,
      }
    },
    components: {
      addDocuments
    },
    props: ['blankModus', 'candidate', 'poolChanges'],
    data() {
      return {
        tempImage: '',
        renderedComponent: true,
        file: null,
        documents: [{
          type: null,
          name: null,
          file: null,
        }],
        profilePicture: {
          profilePicture: true,
          name: 'profilepicture',
          file: null,
        },
        dateNote: new Date()
      }
    },
    methods: {
      handleProfileFileChange() {
        this.$store.commit('setLoading', true)
        this.profilePicture.file = this.$refs.pictureInput.file
        let file = this.profilePicture.file
        let ImgCheck = this.$refs.pictureInput
         ImgCheck.getEXIFOrientation(file, (orientation) => {
             var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              var base64 = reader.result;
              this.resetOrientation(base64, orientation, (resetBase64Image) => {
                let newFile = this.dataURItoBlob(resetBase64Image);
                this.profilePicture.file = newFile
                this.$store.commit('setLoading', false)
              });
            }
          }
        )
      },

      addDocumentRow() {
        this.documents.push({type: null, name: null, file: null});
      },
      removeDocumentRow(index) {
        this.documents.splice(index, 1);
        this.renderComponent();
      },

      renderComponent() {
        this.renderedComponent = false;

        this.$nextTick(() => {
          this.renderedComponent = true;
        });
      },

      convertTimestamps() {
        _.each(this.candidate.certificates, (certificate) => {
          if (certificate.validUntil) {
            certificate.validUntil = moment(certificate.validUntil).format('YYYY-MM-DD');
          }
        });
        _.each(this.candidate.positions, (position) => {
          if (position.startDate) {
            position.startDate = moment(position.startDate).format('YYYY-MM-DD');
          }
          if (position.endDate) {
            position.endDate = moment(position.endDate).format('YYYY-MM-DD');
          }
        });
      },

      saveCandidate(save) {
        this.candidate.createdBy = this.$store.getters.getUserData;
        // this.candidate.createdBy.accessToken = this.$store.state.oAuthToken;
        this.candidate.department = this.$store.getters.getUserData.selectedDepartment ? this.$store.getters.getUserData.selectedDepartment : 'Tilburg'



        let self = this;

        this.$validator.validateAll().then((result) => {
          let validationArrayChild = this.$children.map(function (child) {
            return child.$validator.validateAll();
          });
          Promise.all(validationArrayChild).then((v) => {
            let validCheck = _.includes(v, false);
            if (result && !validCheck) {
              this.convertTimestamps();
              delete this.candidate.age;
              if (this.candidate.bsn) {
                Object.assign(this.candidate, bsnChangeMarker(this.$store.getters.getUserData));
              }
              let newCandidateId = null;
              this.$store.dispatch('candidates/set', _.omit(this.candidate, ['poolChanges'])).then(docRef => {
                newCandidateId = docRef;
                this.candidate.poolChanges.added.forEach(addedPool => {
                  this.$store.dispatch('pools/insert', {
                    candidateId: newCandidateId,
                    customerId: addedPool.id,
                    customerName: addedPool.name,
                    created_at: new Date(),
                    added_by: this.$store.getters.getUserData,
                    department: this.$store.getters.getUserData.selectedDepartment,
                    archived: false
                  })
                });
                self.$FB.collection('candidates').doc(docRef).collection('notes').add({
                  type: 'intake',
                  dateNote: moment(new Date()).format('DD-MM-YYYY'),
                  note: this.candidate.note,
                  createdBy: this.$store.getters.getUserData,
                  department: this.$store.getters.getUserData.selectedDepartment,
                });

                let documentArray = []
                _.each(this.documents, (document) => {
                  if (document.file) {
                    documentArray.push(document)
                  }
                });
                if (this.profilePicture.file) {
                  documentArray.push(this.profilePicture)
                }
                _.each(documentArray, (doc) => {
                  doc.path = '/candidates/' + docRef + '/';
                });
                this.$FB_UPLOADER.upload(documentArray).then(res => {
                  console.log(res)
                })
              }).then(() => {
                this.$emit("unsavedChanges", false);
                if (save === 'newCandidate') {
                  self.$store.commit('setLoading', true, {root: true})
                  setTimeout(function () {
                    self.$store.commit('setLoading', false, {root: true})

                    if (!this.blankModus) {
                      self.$router.go('/candidates/create');
                      self.$toasted.global.successRequest({
                        message: 'Kandidaat aangemaakt',
                      });
                    } else {
                      self.$emit('switchPage', 'candidateInformation');
                    }
                  }, 3000);
                } else if (save === 'findVacancy') {
                  self.$store.commit('setLoading', true, {root: true})
                  setTimeout(function () {
                    self.$store.commit('setLoading', false, {root: true})
                    let candidateObj = self.candidate;
                    self.$router.push({name: 'vacancies', params: {candidateObj}})
                  }, 3000);
                } else if(save === 'planAppointment') {
                  self.$store.commit('setLoading', true, {root: true})
                  setTimeout(function () {
                    self.$store.commit('setLoading', false, {root: true})
                    self.$router.push({ path: `/candidates/${newCandidateId}/appointment`});
                  }, 3000);
                } else {
                  this.$router.push('/candidates');
                  this.$toasted.global.successRequest({
                    message: 'Kandidaat aangemaakt',
                  });
                }
              }).catch((err) => {
                console.log(err)
              })
            } else {
              this.$toasted.global.failedFormRequest();
            }
          }).catch((err) => {
            console.error(err)
          });
        }).catch((err) => {
          console.error(err)
          this.$toasted.global.failedFormRequest();
        });
      },
    },
  }
</script>